import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateCompanyDockActions } from "store/ducks/settings/company-docks";

export function* createCompanyDockRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/company-docks`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateCompanyDockActions.success(data));
    notify("success", "Doca cadastrada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateCompanyDockActions.failure(errorMessage));
  }
}
